export type LogFunction = (label: string, ...args: any[]) => void;

export interface Logger {
    log: LogFunction;
}

const DEBUG = process.env.DEBUG_SDK;

export function createLogger(name: string, color?: string): Logger {
    return {
        log(label: string, ...args: any[]) {
            if (args.length === 0) {
                return;
            }
            if (DEBUG) {
                /* eslint-disable no-console */
                if (color) {
                    console.group(`%c[${name}] ${label}`, `color:${color};`);
                } else {
                    console.group(`[${name}] ${label}`);
                }

                for (const arg of args) {
                    if (arg instanceof Error) {
                        console.error(arg.message);
                    } else if (Array.isArray(arg)) {
                        console.log(...arg);
                    } else if (typeof arg !== 'undefined') {
                        console.log(arg);
                    }
                }
                console.groupEnd();
                /* eslint-enable no-console */
            }
        },
    };
}
